export function setMetaTag(company = null) {
    // const tag = document.createElement('meta')
    // tag.setAttribute('title', info.companies[0].slugName)
    const host = window.location.host;
    const parts = host.split(".");
    let domain = "";
    if ((parts[0] == 'app' || parts[0] == "home" || parts[0].indexOf("localhost") > -1) && company == null) {
        if (parts[1] == 'vknows') {
            domain = 'vknows'
        } else if (parts[1] == 'nerdof') {
            domain = 'nerdof'
        } else {
            domain = 'nerdof'
        }
    } else {
        domain = "other"
    }

    let title = ""
    let logo = ""

    if (domain == "vknows") {
        title = "VKNOWS"
        // logo = "../assets/icon/vknows.ico"
        logo = "https://s3-ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/Logo/vknows.ico"
    } else if (domain == 'nerdof') {
        title = "NerdOf"
        logo = "https://s3-ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/Logo/nerdof.ico"
    } else {
        title = company.title
        logo = company.logo
    }

    document.title = title
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'image/gif/png/icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = logo;
}